// components
import { styled } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

export const StyledCustomNoPaddingIconButton = styled(IconButton)(
  ({ theme }) => ({
    padding: 0,
    color: theme.palette.common.white
  })
);
